import styled, { css } from 'styled-components';

const MapButtonPanel = styled.div`
  position: absolute;
  z-index: 999;
  padding: 0.8em;
  display: flex;
  flex-direction: column;

  /* Make text etc within unselectable */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */

  /* Also necessary to stop user using touch on mobile to zoom in on elements */
  touch-action: none;

  // Position == top-right
  ${props => props.position === 'top-right'
    && css`
      top: var(--app-safe-area-inset-top);
      right: var(--app-safe-area-inset-right);
    `}

  // Position == bottom-right
  ${props => props.position === 'bottom-right'
    && css`
      right: 0px;
      bottom: 20px;
    `}
`;

export default MapButtonPanel;
